import { render, staticRenderFns } from "./LatestTransfers.vue?vue&type=template&id=0137b073&scoped=true&"
import script from "./LatestTransfers.vue?vue&type=script&lang=js&"
export * from "./LatestTransfers.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/content.scss?vue&type=style&index=0&id=0137b073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0137b073",
  null
  
)

export default component.exports